var map = {
	"./footer.png": 408,
	"./footer/anjoman.svg": 409,
	"./footer/daneshbonyan.svg": 410,
	"./footer/enamad.svg": 411,
	"./footer/fab.svg": 412,
	"./footer/instagram.svg": 413,
	"./footer/linkedin.svg": 414,
	"./footer/location.svg": 415,
	"./footer/nezamsenfi.svg": 416,
	"./footer/occc.svg": 417,
	"./footer/phone.svg": 418,
	"./footer/riasatjomhoori.svg": 419,
	"./footer/telegram.svg": 420,
	"./footer/twitter.svg": 421,
	"./footer/youtube.svg": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 229;